export const getMapservice = (
  host: string,
  apiky: string,
  token: string,
  userId: number
) => {
  const reqestURL = `${host}/mapservice/layers?user_id=${userId}`;
  const reqestHeader: HeadersInit = new Headers();
  reqestHeader.set("Content-Type", "application/json");
  reqestHeader.set("Client-Service", "frontend-client");
  reqestHeader.set("Auth-Key", apiky);
  reqestHeader.set("Authorization", token);
  reqestHeader.set("User-ID", `${userId}`);

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader
  })
    .then(response => response.json())
    .then(response => {
      let msLayerList = [];
      if (Array.isArray(response.data)) {
        msLayerList = response.data;
      } else {
        msLayerList = [response.data];
      }
      return msLayerList;
    })
    .catch(error => {
      return error;
    });
};

export const getRequest = (
  host: string,
  apiky: string,
  token: string,
  userId: number,
  layerId: number
) => {
  const reqestURL = `${host}/mapservice/requests?user_id=${userId}&layer_id=${layerId}`;
  const reqestHeader: HeadersInit = new Headers();
  reqestHeader.set("Content-Type", "application/json");
  reqestHeader.set("Client-Service", "frontend-client");
  reqestHeader.set("Auth-Key", apiky);
  reqestHeader.set("Authorization", token);
  reqestHeader.set("User-ID", `${userId}`);

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader
  })
    .then(response => response.json())
    .then(response => {
      let msRqList = [];
      if (Array.isArray(response.data)) {
        msRqList = response.data;
      } else {
        msRqList = [response.data];
      }
      return msRqList;
    })
    .catch(error => {
      return error;
    });
};
